import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'
import { useTranslation } from 'react-i18next'
import { Icon } from 'packages/eid-icons'

const ExpandIcon = styled(Box)(({ theme }) => ({
    width: '1.6rem',
    height: '1.6rem',
    marginLeft: '0.8rem',
    marginTop: '-0.1rem',
    color: theme?.palette?.primary?.main,
}))

const ExpandButton = styled(Box)({
    textTransform: 'uppercase',
    alignItems: 'center',
    '&:hover': {
        cursor: 'pointer',
    },
    '&:focus-visible': {
        outline: '2px solid #0057A0',
        outlineOffset: '2px',
        borderRadius: '4px',
        padding: '2px',
    },
})

const ShowHideButton = (props) => {
    const {
        expanded,
        onClick,
        withLabel = true,
        showLabel = 'Show',
        hideLabel = 'Hide',
    } = props
    const { t } = useTranslation()

    return (
        <Box
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
            fontSize="12px"
            fontWeight="bold"
            color="#0057A0"
        >
            <ExpandButton
                component="span"
                display="flex"
                onClick={onClick}
                role="button"
                aria-expanded={expanded}
                tabIndex={0}
                aria-label={expanded ? t(hideLabel) : t(showLabel)}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault()
                        onClick()
                    }
                }}
            >
                {withLabel && (expanded ? t(hideLabel) : t(showLabel))}
                <ExpandIcon>
                    {expanded ? (
                        <Icon
                            name="MinusCircle"
                            width="1.6rem"
                            height="1.6rem"
                        />
                    ) : (
                        <Icon
                            name="PlusCircle"
                            width="1.6rem"
                            height="1.6rem"
                        />
                    )}
                </ExpandIcon>
            </ExpandButton>
        </Box>
    )
}

export default ShowHideButton
